import { Divider, HStack, VStack } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { isLoading } from "../../../common/helper/commonHelper";
import { FORM_VENDORS } from "../../../common/types/form";
import { FormatDate } from "../../../components/DateTimeRangeFilter";
import { useAppDispatch } from "../../../store";
import FormSubmissionTable, {
  LabelValuePair,
} from "./components/FormSubmissionTable";
import { getSubmissionStatsForSingleForm, selectForm } from "./formSlice";

function SubmissionDetails() {
  const dispatch = useAppDispatch();

  const { formDetails, formSubmissionStat } = useSelector(selectForm);

  useEffect(() => {
    if (formDetails.data?.form_id)
      dispatch(
        getSubmissionStatsForSingleForm({
          source: formDetails.data.vendor,
          formId: formDetails.data.form_id,
        })
      );
  }, [formDetails.data, dispatch]);

  const stat = useMemo(() => {
    if (formSubmissionStat.data && formDetails.data?.form_id) {
      return {
        count:
          formSubmissionStat.data[formDetails.data.form_id]?.count.toString(),
        lastSyncTime:
          formSubmissionStat.data[formDetails.data?.form_id]?.last_sync_time,
      };
    } else {
      return {
        count: "",
        lastSyncTime: undefined,
      };
    }
  }, [formSubmissionStat.data, formDetails.data]);

  return (
    <HStack
      alignItems="flex-start"
      rounded="md"
      bgColor="white"
      w="100%"
      py={2}
      px={4}
      spacing={8}
    >
      <LabelValuePair
        label="Number of submissions"
        value={stat.count}
        isLoadingData={
          isLoading(formDetails.loading) ||
          isLoading(formSubmissionStat.loading)
        }
      />
      <Divider orientation="vertical" />
      <LabelValuePair
        label="Last submission"
        value={<FormatDate date={stat.lastSyncTime} showTime />}
        isLoadingData={
          isLoading(formDetails.loading) ||
          isLoading(formSubmissionStat.loading)
        }
      />
    </HStack>
  );
}

export default function FormDetails({
  id,
  vendor,
}: {
  id: string;
  vendor: FORM_VENDORS;
}) {
  return (
    <VStack w="100%" h="100%" spacing={4}>
      <SubmissionDetails />
      <FormSubmissionTable id={id} vendor={vendor} />
    </VStack>
  );
}
